export default {
  common: {
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    view: 'Ansicht',
    add: 'Hinzufügen',
    search: 'Suchen',
    filter: 'Filter',
    loading: 'Laden...',
    error: 'Fehler',
    success: 'Erfolg'
  },
  nav: {
    dashboard: 'Dashboard',
    members: 'Mitglieder',
    membershipPlans: 'Mitgliedschaftspläne',
    payments: 'Zahlungen',
    attendance: 'Anwesenheit',
    reports: 'Berichte',
    gymProfile: 'Gym-Profil',
    settings: 'Einstellungen',
    logout: 'Abmelden'
  },
  gymProfile: {
    title: 'Gym-Profil',
    languageSettings: 'Spracheinstellungen',
    currentLanguage: 'Aktuelle Sprache',
    selectLanguage: 'Neue Sprache auswählen',
    chooseLanguage: 'Sprache wählen...'
  },
  messages: {
    languageUpdated: 'Sprache erfolgreich aktualisiert!'
  }
};